class HotspotQuickView extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.currentProduct = null;
    this.init();
  }

  init() {
    this.createModal();
    this.attachEventListeners();
  }

  createModal() {
    // Modal HTML'ini oluştur
    const modalHTML = `
      <div class="hotspot-quickview-modal" id="hotspotQuickviewModal" style="display: none;">
        <div class="hotspot-quickview-overlay"></div>
        <div class="hotspot-quickview-container">
          <button class="hotspot-quickview-close" aria-label="Kapat">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div class="hotspot-quickview-content">
            <div class="hotspot-quickview-loading">
              <div class="spinner"></div>
            </div>
          </div>
        </div>
      </div>
    `;
    
    // Modal'ı body'ye ekle
    if (!document.getElementById('hotspotQuickviewModal')) {
      document.body.insertAdjacentHTML('beforeend', modalHTML);
      this.modal = document.getElementById('hotspotQuickviewModal');
      
      // Kapatma butonuna event listener ekle
      const closeBtn = this.modal.querySelector('.hotspot-quickview-close');
      const overlay = this.modal.querySelector('.hotspot-quickview-overlay');
      
      closeBtn.addEventListener('click', () => this.closeModal());
      overlay.addEventListener('click', () => this.closeModal());
      
      // ESC tuşu ile kapatma
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.style.display === 'flex') {
          this.closeModal();
        }
      });
    }
  }

  attachEventListeners() {
    // Hotspot butonlarına click event ekle
    const hotspotButtons = this.querySelectorAll('.hotspot__button');
    const enableQuickview = this.getAttribute('data-enable-quickview') !== 'false';
    
    hotspotButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const blockId = button.getAttribute('data-button');
        
        if (enableQuickview) {
          this.showQuickView(blockId);
        } else {
          // Quickview kapalıysa, sadece içeriği göster
          this.showContent(blockId);
        }
      });
    });
  }

  showContent(blockId) {
    // Mevcut aktif içeriği kaldır
    const allBlocks = this.querySelectorAll('[data-hotspot-block]');
    allBlocks.forEach(block => block.classList.remove('is-active'));
    
    // Seçili bloğu aktif et
    const selectedBlock = this.querySelector(`[data-hotspot-block="${blockId}"]`);
    if (selectedBlock) {
      selectedBlock.classList.add('is-active');
    }
  }

  async showQuickView(blockId) {
    const productBlock = this.querySelector(`[data-hotspot-block="${blockId}"]`);
    
    if (!productBlock || productBlock.getAttribute('data-block-type') !== 'product') {
      return;
    }

    // Modal'ı aç
    this.modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    
    // Loading göster
    const content = this.modal.querySelector('.hotspot-quickview-content');
    content.innerHTML = '<div class="hotspot-quickview-loading"><div class="spinner"></div></div>';

    // Ürün bilgilerini al - farklı selector'lar dene
    const productElement = productBlock.querySelector('.product-grid-item') || 
                          productBlock.querySelector('.grid-product') ||
                          productBlock.querySelector('[data-product-handle]');
    
    if (!productElement) {
      content.innerHTML = '<p>Ürün bulunamadı</p>';
      console.error('Product element not found in block:', productBlock);
      return;
    }

    // Ürün URL'ini farklı yollarla bulmaya çalış
    let productUrl = null;
    const productLink = productElement.querySelector('a.product-link') || 
                       productElement.querySelector('a[href*="/products/"]') ||
                       productElement.querySelector('.grid-product__link') ||
                       productElement.querySelector('a');
    
    if (productLink) {
      productUrl = productLink.getAttribute('href');
    } else {
      // data-product-handle varsa URL'i oluştur
      const productHandle = productElement.getAttribute('data-product-handle');
      if (productHandle) {
        productUrl = `/products/${productHandle}`;
      }
    }

    if (!productUrl) {
      content.innerHTML = '<p>Ürün bilgisi alınamadı</p>';
      console.error('Product URL not found. Product element:', productElement);
      return;
    }

    try {
      // Önce snippet ile render edilmiş içeriği dene
      const snippetResponse = await fetch(`${productUrl}?section_id=product-quickview-snippet`);
      
      if (snippetResponse.ok) {
        const snippetHtml = await snippetResponse.text();
        
        // Eğer snippet varsa ve hata içermiyorsa kullan
        if (snippetHtml && !snippetHtml.includes('Liquid error') && snippetHtml.trim().length > 100) {
          content.innerHTML = snippetHtml;
          return;
        }
      }
      
      // Snippet yoksa veya çalışmadıysa, ürün JSON'ını fetch et
      const productJsonResponse = await fetch(`${productUrl}.js`);
      const productData = await productJsonResponse.json();
      
      // Ürün verisini sakla (varyant güncellemeleri için)
      this.currentProductData = productData;
      
      // Ürün sayfasını da fetch et (görsel ve açıklama için)
      const response = await fetch(productUrl);
      const html = await response.text();
      
      // Normal sayfayı parse et
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Farklı tema yapılarını dene
      const productSection = doc.querySelector('.product-single') || 
                            doc.querySelector('.product') ||
                            doc.querySelector('[data-section-type="product"]') ||
                            doc.querySelector('main');
      
      let quickviewHtml;
      if (productSection) {
        quickviewHtml = this.createQuickViewHTML(productSection, doc, productData);
      } else {
        // Fallback: JSON verisinden oluştur
        console.warn('Product section not found, using JSON data');
        quickviewHtml = this.createQuickViewFromJSON(productData);
      }
      
      content.innerHTML = quickviewHtml;
      
    } catch (error) {
      console.error('Ürün yüklenirken hata:', error);
      content.innerHTML = `<p>Ürün yüklenirken bir hata oluştu</p><p style="font-size: 12px; color: #999;">${error.message}</p>`;
    }
  }

  createQuickViewHTML(productSection, doc, productData) {
    // Farklı tema yapılarını destekle
    const productTitle = productSection.querySelector('.product-single__title, .product__title, h1')?.textContent?.trim() || 'Ürün';
    
    const priceElement = productSection.querySelector('.product__price, .price, .product-single__price');
    const productPrice = priceElement ? priceElement.innerHTML : '';
    
    const productImages = productSection.querySelector('.product__photos, .product-single__photos, .product__media, .product-images');
    const productDescription = productSection.querySelector('.product-single__description, .product__description, .product-description');
    
    // Eğer görsel yoksa featured image'ı al
    let imageHTML = '';
    if (productImages) {
      imageHTML = productImages.innerHTML;
    } else {
      const firstImage = productSection.querySelector('img[src*="products"]');
      if (firstImage) {
        imageHTML = `<img src="${firstImage.src}" alt="${firstImage.alt || productTitle}">`;
      }
    }

    // Ürün URL'ini al
    const productUrl = productData?.url || window.location.pathname;

    return `
      <div class="hotspot-quickview-product">
        <div class="hotspot-quickview-images">
          ${imageHTML || '<div class="placeholder">Görsel yok</div>'}
        </div>
        <div class="hotspot-quickview-info">
          <h2 class="hotspot-quickview-title">${productTitle}</h2>
          ${productPrice ? `<div class="hotspot-quickview-price">${productPrice}</div>` : ''}
          ${productDescription ? '<div class="hotspot-quickview-description">' + productDescription.innerHTML + '</div>' : ''}
          <a href="${productUrl}" class="btn hotspot-view-product-btn">View Product</a>
        </div>
      </div>
    `;
  }

  createQuickViewFromJSON(productData) {
    // JSON verisinden quickview oluştur
    const imageHTML = productData.featured_image 
      ? `<img src="${productData.featured_image}" alt="${productData.title}">`
      : '<div class="placeholder">Görsel yok</div>';

    const priceHTML = productData.price 
      ? `<div class="hotspot-quickview-price">
           ${productData.compare_at_price && productData.compare_at_price > productData.price 
             ? `<span class="compare-at">${this.formatMoney(productData.compare_at_price)}</span>` 
             : ''}
           <span class="money">${this.formatMoney(productData.price)}</span>
         </div>`
      : '';

    const descriptionHTML = productData.description 
      ? `<div class="hotspot-quickview-description">${productData.description.substring(0, 200)}...</div>`
      : '';

    return `
      <div class="hotspot-quickview-product">
        <div class="hotspot-quickview-images">
          ${imageHTML}
        </div>
        <div class="hotspot-quickview-info">
          <h2 class="hotspot-quickview-title">${productData.title}</h2>
          ${priceHTML}
          ${descriptionHTML}
          <a href="${productData.url}" class="btn hotspot-view-product-btn">View Product</a>
        </div>
      </div>
    `;
  }

  formatMoney(cents) {
    // Basit para formatı (tema ayarlarına göre özelleştirilebilir)
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    const value = (parseInt(cents) / 100).toFixed(2);
    return `${value} TL`;
  }

  closeModal() {
    if (this.modal) {
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }
}

// Custom element'i tanımla
if (!customElements.get('hotspot-quickview')) {
  customElements.define('hotspot-quickview', HotspotQuickView);
}
